// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tZPX","content":"styles_content__Mg848"};